import { render } from "./PriceSection.vue?vue&type=template&id=42a9bbad&scoped=true"
import script from "./PriceSection.vue?vue&type=script&lang=js"
export * from "./PriceSection.vue?vue&type=script&lang=js"

import "./PriceSection.vue?vue&type=style&index=0&id=42a9bbad&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a9bbad"]])

export default __exports__